import sharingOptionTypes from 'helpers/enums/activities/sharing/sharingOptionTypes'
import sharingOptionsPayloads from 'helpers/enums/activities/sharing/sharingOptionsPayloads'

function createShareParticipantSubmission(participantUid) {
	const payloadKey = sharingOptionsPayloads[sharingOptionTypes.SUBMISSION]
	return {
		type: sharingOptionTypes.SUBMISSION,
		[payloadKey]: {
			participantUid,
		},
	}
}

export {
	createShareParticipantSubmission,
}
